import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { color } from 'common/helpers'

import { Icon } from 'components/_new/ui'

import s from './PerfumeCaseVolume.scss'


const ProductVolumesPerfumeCaseVolume = ({ className, item, index, isActive, brand, onSelect, withMicrodata, testId }) => {
  let { id, color: itemColor, img, price, inStock } = item
  const hex = Boolean(itemColor) ? `#${itemColor}` : '#8a7f8e'
  const [ _h, _s, lightness ] = color.hexToHslArray(hex)
  const isLightColor = lightness > 70.5
  const borderHex = lightness < 10 ? color.lighter(hex, 20) : color.darker(hex, 10)

  const volumeClassName = cx(s.volume, {
    [s.active]: isActive,
    [s.missingColor]: !itemColor,
  })

  const checkmarkClassName = cx(s.checkmark, {
    [s.black]: isLightColor,
  })

  return (
    <div
      key={id}
      className={cx(className, s.volumeContainer)}
      {...withMicrodata && {
        itemProp: 'offers',
        itemScope: true,
        itemType: 'http://schema.org/Offer',
      }}
    >
      <Fragment>
        <div
          style={{ backgroundColor: hex, borderColor: borderHex }}
          className={volumeClassName}
          data-testid={testId}
          onClick={() => onSelect(index)}
        >
          <Icon
            className={checkmarkClassName}
            name="checkmark"
            color={isLightColor ? 'black' : 'white'}
            noWrapper
          />
        </div>
        {
          withMicrodata && (
            <span style={{ display: 'none' }}>
              <img src={img} alt="volume" itemProp="image" />
              <span itemProp="sku">{id}</span>
              <span itemProp="priceCurrency">USD</span>
              <span itemProp="price">{price / 100}</span>
              <span itemProp="category">{brand}</span>
              <link
                itemProp="availability"
                href={`http://schema.org/${inStock ? 'InStock' : 'OutOfStock'}`}
              />
            </span>
          )
        }
      </Fragment>
    </div>
  )
}

ProductVolumesPerfumeCaseVolume.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    color: PropTypes.string,
    img: PropTypes.string,
    price: PropTypes.number,
    inStock: PropTypes.bool,
  }),
  index: PropTypes.number,
  isActive: PropTypes.bool,
  brand: PropTypes.string,
  onSelect: PropTypes.func,
  withMicrodata: PropTypes.bool,
  testId: PropTypes.string,
}


export default ProductVolumesPerfumeCaseVolume
